import { RightPaneLayout } from "@/components/layout/RightPaneLayout.tsx";
import { GoalDetailPanel } from "@/pages/talent/goals/components/GoalDetailPanel.tsx";
import { useGoalSidePanel } from "@/pages/talent/goals/hooks/use-goal-side-panel.hook.ts";
import { ReactNode } from "react";

export interface GoalPaneLayoutProps {
  children: ReactNode;
}

export function GoalPaneLayout({ children }: GoalPaneLayoutProps) {
  const { sideGoalId, isGoalPanelOpen, closeGoalPanel } = useGoalSidePanel();

  return (
    <RightPaneLayout
      rightPane={
        isGoalPanelOpen && sideGoalId
          ? () => <GoalDetailPanel goalId={sideGoalId} onClose={closeGoalPanel} />
          : undefined
      }
      onHideRightPane={closeGoalPanel}
    >
      {children}
    </RightPaneLayout>
  );
}
